import type { SlateEditor } from '@udecode/plate';
import { useEditorPlugin } from '@udecode/plate/react';
import {
    type DeserializeMdOptions,
    MarkdownPlugin,
} from '@udecode/plate-markdown';
import { useEffect, useMemo } from 'react';

import { AIChatPlugin } from '../AIChatPlugin';

/**
 * Register an editor in the AI chat plugin, and deserializes the content into
 * `editor.children` with block-level memoization.
 */
export const useAIChatEditor = (
    editor: SlateEditor,
    content: string,
    { parser, processor }: DeserializeMdOptions = {}
) => {
    const { setOption } = useEditorPlugin(AIChatPlugin);

    editor.children = useMemo(
        () => {
            return editor.getApi(MarkdownPlugin).markdown.deserialize(content, {
                memoize: true,
                parser,
                processor,
            });
        },
        [content]
    );

    useEffect(() => {
        setOption('aiEditor', editor);
    }, [editor, setOption]);
};
